module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-16-9bb8ca324ba5b9479cc88fd6a1af44d6.svg";